jQuery(document).ready(function () {


	/**
	 * breakpoints for responsivness
	 * @link https://github.com/jerrylow/breakpoints
	 */

	jQuery(window).breakpoints({
		breakpoints: [{
			"name": "sm",
			"width": 576
		}, {
			"name": "md",
			"width": 768
		}, {
			"name": "lg",
			"width": 992
		}, {
			"name": "xl",
			"width": 1200
		}]
	});

	/**
	 * detects external links and adds target="_blank"
	 */

	var host = window.location.host;

	jQuery('a').not('[href*="' + host + '"]').filter(function () {
		return this.hostname && this.hostname !== location.hostname;
	}).attr('target', '_blank').attr('rel', 'noopener');


	/**
	 * faq
	 */

	jQuery('.js-faq-question').on('click', function () {
		jQuery(this).siblings('.js-faq-answer').toggleClass('hidden');
		jQuery(this).find('.js-faq-icon').toggleClass('jam-plus');
	});


	/**
	 * smooth scroll
	 */

	jQuery('a[href*="#"]').not('[href="#"]').not('[href="#0"]').click(function (event) {
		// On-page links
		if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
			// Figure out element to scroll to
			var target = $(this.hash);
			target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
			// Does a scroll target exist?
			if (target.length) {
				// Only prevent default if animation is actually gonna happen
				event.preventDefault();
				$('html, body').animate({
					scrollTop: target.offset().top
				}, 1000, function () {
					// Callback after animation
					// Must change focus!
					var $target = $(target);
					$target.focus();
					if ($target.is(":focus")) { // Checking if the target was focused
						return false;
					} else {
						$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
						$target.focus(); // Set focus again
					};
				});
			}
		}
	});



	/**
	 * sticky message
	 */

	const $stickyBtn = jQuery('.js-sticky-button');
	const $stickyMenu = jQuery('.js-sticky-menu');
	function triggerSticky() {
		$stickyMenu.addClass('sticky-menu-active');
		$stickyBtn.find('.jam').toggleClass('jam-message-writing');
		jQuery('.js-sticky-welcome').removeClass('sticky-welcome-active').addClass('hidden');
	}

	function closeSticky() {
		$stickyMenu.removeClass('sticky-menu-active');
		$stickyBtn.find('.jam').addClass('jam-message-writing');
	}

	// makes the button show
	setTimeout(function () {
		$stickyBtn.addClass('sticky-button-active');
	}, 1000);

	// makes the welcome message show
	setTimeout(function () {
		jQuery('.js-sticky-welcome').addClass('sticky-welcome-active');
		var valObj = {
			show: true,
		}
		setCookie("welcome-message", valObj, 1);
	}, 4000);

	// hides the welcome message
	setTimeout(function () {
		jQuery('.js-sticky-welcome').removeClass('sticky-welcome-active');
	}, 10000);

	// on button click opens or closes menu
	$stickyBtn.on('click', function () {
		if($stickyMenu.hasClass('sticky-menu-active')) {
			closeSticky();
		} else {
			triggerSticky();
		}
	});

	// when clicking inside any of the named classes don't do anything
	jQuery('.js-sticky-menu, .js-sticky-welcome').on('click', function (e) {
		e.stopPropagation();
	});

	// outside of the named classes do this
	jQuery(document).on('click', function (e) {
		if (!jQuery(e.target).hasClass('sticky-button-icon') && !jQuery(e.target).hasClass('js-sticky-button')) {
			closeSticky();
		}

	})

	jQuery(document).on('click', function (e) {
		var target = jQuery(e.target);
		if (target.hasClass('js-overlay') && target.hasClass('js-overlay-active')) {
			jQuery('.js-overlay').removeClass('js-overlay-active');
			jQuery('.js-overlay input').prop('checked', false);
			jQuery('.js-overlay-submit').prop('disabled', true);

		}
		if (target.hasClass('js-overlay-close')) {
			jQuery('.js-overlay').removeClass('js-overlay-active');
			jQuery('.js-overlay input').prop('checked', false);
			jQuery('.js-overlay-submit').prop('disabled', true);
		}
	});


	/**
	 * newsletter
	 */

	const verifyEmail = email => {
		if (email) {
			if (email.val() !== '') {
				var reGex = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				if (reGex.test(email.val())) {
					return true;
				}
			}
		}
		return false;
	}

	//trigger pop up for newsletter
	if (window.location.href.indexOf('#nyhetsbrev') > 0) {
		$stickyBtn.find('.jam').addClass('jam-message-writing');
		$stickyMenu.removeClass('sticky-menu-active');
		jQuery('.js-overlay-newsletter').toggleClass('js-overlay-active');
	}

	jQuery('.js-newsletter').on('click', function (e) {
		e.preventDefault();
		$stickyBtn.find('.jam').addClass('jam-message-writing');
		$stickyMenu.removeClass('sticky-menu-active');
		jQuery('.js-overlay-newsletter').toggleClass('js-overlay-active');
	});

	jQuery('.js-newsletter-submit').on('click', function (e) {
		var $btn = $(this);
		var $form = $btn.closest('.js-newsletter-form');
		var $complete = $form.siblings('.js-newsletter-complete');
		setTimeout(function () { //set timeout so that form submit can fire
			$form.remove();
			$complete.removeClass('hidden');
			setTimeout(function () { jQuery('.js-overlay-newsletter').removeClass('js-overlay-active') }, 4500); //remove popup after sometime
		}, 1000);

	});

	var newsletterForms = jQuery('.js-newsletter-form');
	newsletterForms.each(function() {
		var $form = $(this);
		var checkBoxes = $form.find('.js-newsletter-checkbox');
		checkBoxes.change(function () {
			var $this = $(this);
			if ($this.val() !== '') {
				$form.find('.js-newsletter-submit').prop('disabled', checkBoxes.filter(':checked').length < 1);
			}
		});
		checkBoxes.change();
	});


	/**
	 * filter expert
	*/

	function activeSearch() {
		jQuery('.js-search-field-icon').children().removeClass('jam-search');
		jQuery('.js-search-field').focus();
		$stickyMenu.removeClass('sticky-menu-active');
		jQuery('.js-sticky-welcome').removeClass('sticky-welcome-active');
		$stickyBtn.find('.jam').addClass('jam-envelope');
	}

	function unactiveSearch() {
		jQuery('.js-search-field-icon').children().addClass('jam-search');
		jQuery('.js-search-field').focusout();
	}

	jQuery('.js-search-field-icon').on('click', function () {
		jQuery('.js-search-field').val('');
	});

	jQuery('.js-search-field').on('click', function (e) {
		e.stopPropagation();
	});

	jQuery(".js-search-field").on('click', function () {
		activeSearch();
	});

	jQuery(document).on('click', function () {
		unactiveSearch();
	})


	/**
	 * journal disease/symptom filtering
	 */

	jQuery('.js-archive-buttons').on('click', '.js-archive-button', function () {
		var $this = jQuery(this);

		var letter = $this.data('letter');
		jQuery('.js-archive-button').addClass('text-whisper');
		$this.removeClass('text-whisper');
		jQuery('.js-all-archive-button').addClass('text-whisper');

		jQuery('.js-archive-list').filter(function () {
			var $this = $(this);
			if ($this.data('group-letter') == letter) {
				$this.removeClass('hidden').addClass('block').removeAttr('hidden');
			} else {
				$this.removeClass('block').addClass('hidden').attr('hidden', true);
			}
		});

		//scroll to the results
		$('html, body').animate({
			scrollTop: $(".components-misc-archive-section").offset().top
		}, 500);

	});

	jQuery('.js-all-archive-button').on('click', function () {
		jQuery('.js-archive-list').removeClass('hidden block');
		jQuery('.js-archive-button').addClass('text-whisper');
		jQuery(this).removeClass('text-whisper');
	})

	//filter on input search
	$('.js-search-archive').on('change keyup', function (e) {

		var searchValue = $(this).val().toLocaleLowerCase(); // Fetch value

		if (searchValue.length == 0) { //reset
			$.each($('.js-archive-list'), function (i, l) {
				$(this).removeClass('hidden')
			});
			$.each($('.js-archive-list li'), function (i, l) {
				$(this).removeClass('hidden')
			});
		}

		if ($('.js-archive-list').hasClass('js-archive-list-assoscations')) {

			$.each($('.js-archive-list-assoscations'), function (i, l) {
				var parentEl = this
				$(parentEl).addClass('hidden') //hide all parent elements

				$.each($(parentEl).find('.js-assoscations-title'), function (i, l) {
					$(this).parents('.components-patient-assoscations-excerpt-block-1').addClass('hidden') //hide all terms
					if ($(this).text().replace(/\s/g, '').toLowerCase().includes(searchValue)) {
						//show terms and elements that have search value in it
						$(parentEl).removeClass('hidden')
						$(this).parents('.components-patient-assoscations-excerpt-block-1').removeClass('hidden')
					}
				});

			});

		} else {

			$.each($('.js-archive-list'), function (i, l) {
				var parentEl = this
				$(parentEl).addClass('hidden') //hide all parent elements

				$.each($(parentEl).find('li'), function (i, l) {
					$(this).addClass('hidden') //hide all terms
					if ($(this).text().replace(/\s/g, '').toLowerCase().includes(searchValue)) {
						//show terms and elements that have search value in it
						$(parentEl).removeClass('hidden')
						$(this).removeClass('hidden')
					}
				});

			});

		}

	});

	function activeArchiveSearch() {
		jQuery('.js-search-archive-icon').children().removeClass('jam-search');
		jQuery('.js-search-field').focus();
		$stickyMenu.removeClass('sticky-menu-active');
		jQuery('.js-sticky-welcome').removeClass('sticky-welcome-active');
		$stickyBtn.find('.jam').addClass('jam-envelope');
	}

	function unactiveArchiveSearch() {
		jQuery('.js-search-archive-icon').children().addClass('jam-search');
		jQuery('.js-search-field').focusout();
	}

	jQuery('.js-search-archive-icon').on('click', function () {
		jQuery('.js-search-archive').val('');

		var searchValue = $('.js-search-archive').val().toLocaleLowerCase(); // Fetch value

		if (searchValue.length == 0) { //reset
			$.each($('.js-archive-list'), function (i, l) {
				$('.js-search-archive').removeClass('hidden')
			});
			$.each($('.js-archive-list li'), function (i, l) {
				$('.js-search-archive').removeClass('hidden')
			});
		}

		if ($('.js-archive-list').hasClass('js-archive-list-assoscations')) {

			$.each($('.js-archive-list-assoscations'), function (i, l) {
				var parentEl = this
				$(parentEl).addClass('hidden') //hide all parent elements

				$.each($(parentEl).find('.js-assoscations-title'), function (i, l) {
					$(this).parents('.components-patient-assoscations-excerpt-block-1').addClass('hidden') //hide all terms
					if ($(this).text().replace(/\s/g, '').toLowerCase().includes(searchValue)) {
						//show terms and elements that have search value in it
						$(parentEl).removeClass('hidden')
						$(this).parents('.components-patient-assoscations-excerpt-block-1').removeClass('hidden')
					}
				});

			});

		} else {

			$.each($('.js-archive-list'), function (i, l) {
				var parentEl = this
				$(parentEl).addClass('hidden') //hide all parent elements

				$.each($(parentEl).find('li'), function (i, l) {
					$(this).addClass('hidden') //hide all terms
					if ($(this).text().replace(/\s/g, '').toLowerCase().includes(searchValue)) {
						//show terms and elements that have search value in it
						$(parentEl).removeClass('hidden')
						$(this).removeClass('hidden')
					}
				});

			});

		}
	});

	jQuery('.js-search-archive').on('click', function (e) {
		e.stopPropagation();
	});

	jQuery(".js-search-archive").on('click', function () {
		activeArchiveSearch();
	});

	jQuery(document).on('click', function () {
		unactiveArchiveSearch();
	})



	/**
	 * cookie disclaimer
	 */

	if (getCookie("CookieConsent") === undefined && jQuery(".js-cookie-disclaimer").hasClass("js-cookie-disclaimer-active")) {
		jQuery(".js-sticky-menu").addClass('js-cookie-sticky-navigation');
		jQuery(".js-sticky-welcome, .js-sticky-button").addClass('js-cookie-sticky-navigation');
	}

	jQuery(".js-cookie-disclaimer-accept").on("click", function (e) {
		e.preventDefault();
		jQuery(".js-cookie-disclaimer").removeClass("js-cookie-disclaimer-active");
		jQuery(".js-sticky-menu").removeClass('js-cookie-sticky-navigation');
		jQuery(".js-sticky-welcome, .js-sticky-button").removeClass('js-cookie-sticky-navigation');

		var valObj = {
			fullSite: true,
		}
		setCookie("CookieConsent", valObj, 30);
	});



	//open social share into a new window
	$('.social-share').on('click', function (e) {
		e.preventDefault();
		var strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
		window.open(this.href, "_blank", strWindowFeatures);
	})


	//lose focus on enter keypress(sympotom input field)
	if (document.getElementsByClassName('js-search-archive')[0]) {
		document.getElementsByClassName('js-search-archive')[0].addEventListener('keyup', function (e) {
			if (e.which == 13) this.blur();
		});
	}

	function isTextInput(node) {
		return ['INPUT', 'TEXTAREA'].indexOf(node.nodeName) !== -1;
	}

	document.addEventListener('touchstart', function (e) {
		if (!isTextInput(e.target) && isTextInput(document.activeElement)) {
			document.activeElement.blur();
		}
	}, false);

	/**
	 * Tab panels
	 * Inspired from https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role
	 */
	$('.js-tabs').each(function() {
		const $wrapper = $(this);
		const tabButtons = $wrapper.find('button[role="tab"]');
		tabButtons.on('click', function(e) {
			$wrapper.find('div[role="tabpanel"]').attr('hidden', true);
			tabButtons.filter('[aria-selected="true"]').attr('aria-selected', 'false');
			$('#' + $(this).attr('aria-controls')).removeAttr('hidden');
			$(this).attr('aria-selected', 'true');
		});
	});


});

function setCookie(name, values, exdays, options = {SameSite: 'strict'}) {
	var d = new Date();
	d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
	options = {
		path: "/",
		expires: d.toGMTString(),
		...options
	};

	let cookie = encodeURIComponent(name) + '=' + JSON.stringify(values)

	for (let optionKey in options) {
		cookie += "; " + optionKey;
		let optionValue = options[optionKey];
		if (optionValue !== true) {
			cookie += "=" + optionValue;
		}
	}

	document.cookie = cookie;
}

// returns the cookie with the given name,
// or undefined if not found
function getCookie(name) {
	let matches = document.cookie.match(
		new RegExp(
			"(?:^|; )" +
			name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
			"=([^;]*)"
		)
	);
	return matches ? decodeURIComponent(matches[1]) : undefined;
}


var openOrPlay = function () {
	$(".rs_playbtn").hide();
	$('#readspeaker').show();
}

window.rsConf = {
	general: { usePost: true },
	cb: {
		ui: {
			beforeclose: function () {
				$('#readspeaker').hide();
				$(".rs_playbtn").show();
			},
			open: openOrPlay,
			play: openOrPlay,
		}
	}
};
